<template>
  <div class="container mt-5 text-center">
    <h3>Tareas</h3>
    <div v-if="loading" class="spinner-border mt-2 bg-light" role="status">
      <span  class="sr-only">Loading...</span>
    </div>
    <!-- <div class="card-body p-0"> -->
      <!-- Map Container -->
      <!-- <div ref="mContainer" width="100%" height="100%" style="width: 100%; height: 180px;"></div> -->
      <!-- Countries Table List -->
      <div class="container">
        <div class="table-responsive">
          <table class="table" style="width:100% !important">
            <thead>
              <tr>
                <th>Id</th>
                <th>Asunto</th>
                <th>De</th>
                <th>Fecha Ini</th>
                <th>Fecha Fin</th>
                <th>terminada</th> 
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id"> 
                <td class="text-center">{{ item.tarea_id }}</td>
                <td class="text-center">{{ item.asunto }}</td>
                <td class="text-center">{{ item.ude }}</td>
                <td class="text-center">{{ item.fechaini != null ? $moment(item.fechaini).format('DD-MM-YYYY') : ''  }}</td>
                <td class="text-center">{{ item.fechafin != null ? $moment(item.fechafin).format('DD-MM-YYYY') : '' }}</td>
                <td class="text-center">{{ item.porcompletada }}%</td>
                <td class="text-center">
                  <button type="button" class="btn btn-primary" @click="showModal(item)">
                    Ver
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    <!-- </div> -->
    <div>
      <simple-modal v-model="isShow" title="Detalle de la Tarea">
        <template slot="body">
          <!-- <h5>Detalle</h5> -->
          <div v-if="loading2" class="spinner-border mt-2" role="status"></div><br>
          <div class="row">
            <div class="col-4">
              <span>terminada: </span>
            </div>
            <div class="col-8">
              <input style="float: left !important;" min="0" max="100" class=" ml-5 mb-4" type="number" v-model="row.porcompletada" />
            </div>
          </div>
          <textarea v-model="row.descripcio" cols="55" rows="10" style="width:90%"></textarea>
          <br>
          <button @click="saveData()" class="btn btn-primary mt-3 ml-3">Guardar</button>
          <button @click="isShow= false" class="btn btn-primary mt-3 ml-3">Cerrar</button>
        </template>
        <template slot="footer">
          <button>OK</button>
        </template>
      </simple-modal>
    </div>
  </div>
</template>
  
<script>
import SimpleModal from 'simple-modal-vue'

  import api from "../config/api";
  export default {
    components: { SimpleModal },
    data(){
      return{
        items:[],
        user: null,
        loading: false,
        isShow: false,
        row:{},
        loading2: false,
      }
    },
    async mounted() {
      this.$isLoading(true)
      this.user = JSON.parse(localStorage.getItem('user'));
      console.log('-->', this.user)
      await this.getData()
      this.$isLoading(false)
    },
    methods:{
      showModal(item){
        localStorage.setItem('row', JSON.stringify(item))
        this.$router.push('detalleTarea')
        // this.row = item
        // this.isShow= true
      },
      async getData(){
        console.log('tareas')
        let resultv = await api.request("get", '/BMGES_tareas/' + this.user.numero);
        let res = resultv.data
        this.items = res
        console.log('tareas items', this.items)
        //console.log('tareas', resultv)
      },
      async saveData(){
        this.loading2 = true
        let data={
          porcompletada : this.row.porcompletada,
          descripcio: this.row.descripcio
        }
        let resultv = await api.request("put", '/BMGES_actualizaTareas/' + this.row.tarea_id,  data);
        let res = resultv.data
        this.isShow= false
        await this.getData()
        this.loading2 = false
        //console.log('tareas', resultv)
      }
    }
  }
</script>

<style>

</style>